import React, { useEffect, useState } from 'react';

import {
  Box,
  Button,
  CircularProgress,
  InputAdornment,
  TextField,
} from '@mui/material';

import { Search } from '@mui/icons-material';

import { useCopilotContext } from '../../contexts/CopilotContext';
import DocumentList from './DocumentList';
import DocumentView from './DocumentView';
import SearchResults from './SearchResults';

import { IViewDocument } from '@homeporter/types';
import { useKnowledgeBaseStyles } from './styles';

const KnowledgeLibrary = () => {
  const styles = useKnowledgeBaseStyles();
  const {
    documentParagraphMapRef,
    documentLoading,
    documentError,
    clearError,
    viewDocument,
    searchLoading,
    searchError,
    searchEnqueue,
    searchResults,
    clearSearchResults,
    setViewDocument,
    copilotEnabled,
    setCopilotEnabled,
  } = useCopilotContext();

  const [search, setSearch] = useState('');
  const [viewedSection, setViewedSection] = useState<IViewDocument | null>();
  const [selectedDocument, setSelectedDocument] = useState<IViewDocument>();

  const error = searchError || documentError;

  const handleEnterKeyPress = (
    event: React.KeyboardEvent<HTMLInputElement>,
  ) => {
    if (event.key === 'Enter') {
      setViewDocument(null);
      setSearch((event.target as HTMLInputElement).value);
      searchEnqueue({
        sid: '',
        text: (event.target as HTMLInputElement).value,
      });
    }
  };

  useEffect(() => {
    clearSearchResults();
  }, []);

  const handleBackButton = () => {
    if (viewedSection && selectedDocument) {
      setViewDocument(selectedDocument);
      setViewedSection(null);
    } else {
      setViewDocument(null);
    }
  };

  console.log(
    ':::::KnowledgeLibrary viewDocument:',
    viewDocument,
    'searchResults:',
    searchResults,
  );

  return (
    <>
      <Box sx={{ width: '100%' }}>
        <Box sx={styles.inputs}>
          <TextField
            sx={styles.text}
            size="small"
            fullWidth
            label={'Search the Knowledge Base'}
            onKeyDown={handleEnterKeyPress}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
          />
        </Box>

        {searchLoading && (
          <Box sx={styles.center}>
            <CircularProgress />
          </Box>
        )}

        {error && (
          <Box sx={styles.center}>
            Error !{' '}
            <Button
              onClick={() => {
                clearError();
              }}>
              X
            </Button>
          </Box>
        )}

        {!searchLoading &&
          !error &&
          (viewDocument ? (
            <DocumentView
              clearSearchResults={clearSearchResults}
              handleBackButton={handleBackButton}
              viewDocument={viewDocument}
              setViewDocument={setViewDocument}
              documentParagraphMapRef={documentParagraphMapRef}
              searchResults={searchResults}
              documentLoading={documentLoading}
            />
          ) : searchResults ? (
            <SearchResults
              openCopilot={() => setCopilotEnabled(!copilotEnabled)}
              search={search}
            />
          ) : (
            <Box
              sx={{
                width: '100%',
                overflowY: 'auto',
                height: 'calc(100% - 6rem)',
              }}>
              <DocumentList setSelectedDocument={setSelectedDocument} />
            </Box>
          ))}
      </Box>
    </>
  );
};

export default KnowledgeLibrary;
